import { INavigationMenu } from 'interfaces/navigationMenu.interface'

export type RSVEpidemiologySlugs =
  | 'epidemiology-across-respiratory-diseases'
  | 'hemispheres'
  | 'us-states'
  | 'hospitalisations'
  | 'research-briefs'

const RSVEpidemiologyMenu: Array<INavigationMenu<RSVEpidemiologySlugs>[]> = [
  [
    {
      title: 'Epidemiology across Respiratory Diseases',
      slug: 'epidemiology-across-respiratory-diseases',
      createdAt: new Date(2025, 7, 26),
    },
    {
      title: 'Hospitalisations',
      slug: 'hospitalisations',
      createdAt: new Date(2023, 2, 13),
    },
    {
      title: 'Research Briefs',
      slug: 'research-briefs',
      createdAt: new Date(2024, 1, 25),
    },
  ],
]

export { RSVEpidemiologyMenu }
